var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-position":"center top","background-repeat":"no-repeat","background-size":"cover"},style:({ 'background-image': `url('${ _vm.thumbnail }'), url('${ _vm.defaultThumbnail }')`})})
}
var staticRenderFns = []

export { render, staticRenderFns }